import {
  GROW_RICH,
  FOR_THE_YOUNG_INDIA,
  PLAN_YOUR_CHILDS_FUTURE,
} from './funds';

export const POPULAR = [
  GROW_RICH,
  FOR_THE_YOUNG_INDIA,
  PLAN_YOUR_CHILDS_FUTURE,
];



// WEBPACK FOOTER //
// ./constants/fundBuckets/popular.ts